import { useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { usePhotoCardMarketPopupStore } from '../store/usePhotoCardMarketPopupStore';

const WriteReviewPopup = () => {
  const navigate = useNavigate();
  const { setIsWriteReviewPopupOpen, selectedTradingPhotoCard } = usePhotoCardMarketPopupStore();

  const { tradingPhotoCardId, chatRoomId, traderUserProfileId, reviewableType } =
    selectedTradingPhotoCard ?? {};

  const handleNavigateToReview = () => {
    navigate(
      `/reviews/add-review?chatRoomId=${chatRoomId}&traderUserProfileId=${traderUserProfileId}&reviewableId=${tradingPhotoCardId}&reviewableType=${reviewableType}`
    );
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 dark:bg-black/55 z-10">
      <div
        className={
          'flex flex-col gap-[40px] bg-background-elevated rounded-[24px] px-[14px] pt-[32px] pb-[16px] mb-[10px] w-[311px] h-[284px] fixed bottom-[36px] left-1/2 transform -translate-x-1/2 z-20'
        }
      >
        <div className="flex flex-col gap-[8px] leading-tight items-center">
          <p className="h-[40px] text-text-main-lv1 font-bold text-[17px] text-center">
            <Trans
              i18nKey="NewTradingPhotoCardMarket.writeReviewPopupTitle"
              components={{ br: <br /> }}
            />
          </p>
          <p className="h-[36px] text-text-main-lv4 text-[15px] text-center">
            <Trans
              i18nKey="NewTradingPhotoCardMarket.writeReviewPopupDescription"
              components={{ br: <br /> }}
            />
          </p>
        </div>
        <div className="flex flex-col gap-[8px] leading-none">
          <Button
            btnColor="primary"
            size="large"
            onClick={handleNavigateToReview}
            className="text-[17px] font-semibold"
          >
            {t('NewTradingPhotoCardMarket.moveToReview')}
          </Button>
          <Button
            btnColor="secondary"
            size="large"
            onClick={() => setIsWriteReviewPopupOpen(false)}
            className="text-[17px] font-semibold"
          >
            {t('NewTradingPhotoCardMarket.notYetCompleted')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WriteReviewPopup;
